export const DELETE_LABEL_MODAL_LABELS = {
	TITLE: 'Delete label?',
	BODY: (displayName: string): string =>
		`Are you sure you want to delete the label "${displayName}"? This action is irreversible and will remove all associated values.`,
	CONFIRM: 'Delete',
	CANCEL: 'Cancel',
	DELETE_FAILED: 'Could not delete the label. Please try again.'
} as const;
